const getMediaTemplate = (maxWidth) => `@media (max-width: ${maxWidth}px)`;
export var SCREEN_WIDTH;
(function (SCREEN_WIDTH) {
    SCREEN_WIDTH[SCREEN_WIDTH["MOBILE_S"] = 320] = "MOBILE_S";
    SCREEN_WIDTH[SCREEN_WIDTH["MOBILE_M"] = 375] = "MOBILE_M";
    SCREEN_WIDTH[SCREEN_WIDTH["MOBILE_L"] = 425] = "MOBILE_L";
    SCREEN_WIDTH[SCREEN_WIDTH["MOBILE"] = 767] = "MOBILE";
    SCREEN_WIDTH[SCREEN_WIDTH["SMALL_TABLET"] = 992] = "SMALL_TABLET";
    SCREEN_WIDTH[SCREEN_WIDTH["TABLET"] = 1024] = "TABLET";
    SCREEN_WIDTH[SCREEN_WIDTH["SMALL_DESKTOP"] = 1350] = "SMALL_DESKTOP";
    SCREEN_WIDTH[SCREEN_WIDTH["PRINT"] = Number.MAX_SAFE_INTEGER] = "PRINT";
})(SCREEN_WIDTH || (SCREEN_WIDTH = {}));
export const media = {
    mobileS: getMediaTemplate(SCREEN_WIDTH.MOBILE_S),
    mobileM: getMediaTemplate(SCREEN_WIDTH.MOBILE_M),
    mobileL: getMediaTemplate(SCREEN_WIDTH.MOBILE_L),
    mobile: getMediaTemplate(SCREEN_WIDTH.MOBILE),
    smallTablet: getMediaTemplate(SCREEN_WIDTH.SMALL_TABLET),
    tablet: getMediaTemplate(SCREEN_WIDTH.TABLET),
    smallDesktop: getMediaTemplate(SCREEN_WIDTH.SMALL_DESKTOP),
    print: getMediaTemplate(Number.MAX_SAFE_INTEGER),
};
/**
 * Generates a media template, see sample implementation below:
 *
 * styled.img`
 *    overflow: hidden;
 *
 *    ${media.mobile} {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
 * `
 */
export const isWindowMobile = () => {
    if (typeof window !== 'undefined') {
        return window.screen.width <= SCREEN_WIDTH.MOBILE;
    }
    else {
        return null;
    }
};
// TODO: remove and fixed import statements in components for consistency
export default media;
